<script setup>
// import moment from "moment"
</script>

<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Aspek Pengelolaan Lingkungan Hidup
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <div class="container my-4">
                <penilaianCalonPenanggungJawab />

                <p
                  class="mb-3 mt-4"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  PENILAIAN TEKNIS PRESENTASI
                </p>
                <formPenilaian
                  :evaluationItems="evaluationItems"
                  @updateEvaluationItems="evaluationItems = $event"
                />

                <div class="d-flex justify-content-end mt-3">
                  <button
                    type="button"
                    class="btn btn_cari w-25"
                    @click="console.log(evaluationItems)"
                  >
                    Approve
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
</template>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"
// import axios from "axios";
// import Swal from "sweetalert2"

import "@/pages/sio/assets/penilaian-presentasi.css";
import penilaianCalonPenanggungJawab from "@/pages/sio/penilaian/penilaianCalonPenanggungJawab.vue";
import formPenilaian from "@/pages/sio/penilaian/formPenilaian.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

export default {
  mixins: [GlobalDataMixin],
  name: "aspekPengelolaanLingkunganHidup",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
    formPenilaian,
    penilaianCalonPenanggungJawab,
  },
  data() {
    return {
      evaluationItems: [
        {
          criteria: "Calon PJO mampu menjelaskan pengelolaan aspek teknis",
          score: 0,
          maxScore: 2,
          note: "Surat permohonan belum memadai",
          isEditingNote: false,
          editNote: "",
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style></style>
